// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__9SXHQ","popup__title":"errorPopup_popup__title__9Sh4l","popup__img":"errorPopup_popup__img__ifNz9","popup__nextBtn":"errorPopup_popup__nextBtn__QDLDD"};